import { formatDateForDisplay, formatRelativeDate, formatDateTimeForDisplay } from "utils/utils";

export const DateCell = (info) =>
  formatDateForDisplay(info.getValue(), { addSuffix: true });

export const RelativeDateCell = (info) =>
  formatRelativeDate(info.getValue(), { addSuffix: true });

export const DateTimeCell = (info) =>
  formatDateTimeForDisplay(info.getValue(), { addSuffix: true });
